<template>
  <div class="Platform403ErrorView">
    <PlatformErrorMessage title="Brak dostępu"
                          description="Niestety ale nie masz uprawnień do tej części aplikacji"
    />
  </div>
</template>

<script>
import PlatformErrorMessage from '@/components/Platform/TheErrorMessage';

export default {
  name: 'Platform403Error',

  components: {
    PlatformErrorMessage,
  },
};
</script>
